module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.a553f44a.woff2";